const PATH = '/login';

export default PATH;
